import {useState, useEffect} from "react";
import {MyAppsResponse, MyGroupApps} from "../logic/APITypes";
import API from "../logic/API";
import {Resolution} from "../logic/FetchResolver";

const adjustLogo = (app: MyAppsResponse) => ({
  ...app,
  logo: "data:image/svg+xml;base64," + app.logo,
});

/** A hook for fetching installed apps for a user from the API */
function useMyApps() {
  const [myApps, setMyApps] = useState<MyGroupApps[]>([]);
  const [loading, setLoading] = useState(true);
  const getMyApps = async () => {
    setLoading(true);
    const res: Resolution<MyAppsResponse[]> = await API.getMyApps();
    setLoading(false);
    if (res.success && res.payload) {
      const myGroupApps: MyGroupApps[] = [];
      for (const app of res.payload) {
        const groupIndex = myGroupApps.findIndex((g) => g.id === app.group_id);
        if (groupIndex === -1)
          myGroupApps.push({
            id: app.group_id,
            name: app.group_name,
            apps: [adjustLogo(app)],
          });
        else myGroupApps[groupIndex].apps.push(adjustLogo(app));
      }
      setMyApps(myGroupApps);
    }
  };

  useEffect(() => {
    getMyApps();
  }, []);
  return {myApps, loading};
}

export default useMyApps;
